import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { LanguageService } from '../../services/LanguageService'
import { resetStore } from '../../actions/settings/SettingsAction'
import { getTranslations } from '../../actions/TranslationsAction'
import { TriggerEvents, TriggerHelper } from './businessRules/TriggerHelper'

class Language extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
        }
        this.wrapperRef = this.wrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    handleHover = () => {
        this.setState({ show: true });
    }

    handleBlur = () => {
        this.setState({ show: false });
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidUpdate(prevProps) {
        const { popupVisible } = this.props;
        if (!popupVisible && prevProps.popupVisible) {
            this.setState({ show: false });
        }
    }

    selectLanguage = (lang) => {
        const { history } = this.props;
        let prevLang = LanguageService.getSelectedLanguage();
        let newPath = history.location.pathname.replace(`/${LanguageService.getSelectedLanguage()}/`, `/${lang}/`);
        if (newPath === history.location.pathname) {
            newPath = history.location.pathname.replace(`/${LanguageService.getSelectedLanguage()}`, `/${lang}`);
        }

        this.props.dispatch(resetStore());
        LanguageService.setSelectedLanguage(lang);
        this.props.dispatch(getTranslations(lang));
         /* Trigger custom event for language change */
        TriggerHelper.triggerEvent(TriggerEvents.languageChange, {lang,prevLang});
        history.replace(newPath);
    }

    wrapperRef(node) {
        this.langRef = node;
    }

    findControlSection(rootControl, name) {
        if (!rootControl) {
            return null;
        }

        if (rootControl.name === name) {
            return rootControl;
        } else if (rootControl.nestedControls) {

            let result = null;
            for (let i = 0; i <= rootControl.nestedControls.length; i++) {
                if (rootControl.nestedControls[i]) {
                    result = this.findControlSection(rootControl.nestedControls[i], name);
                    if (result)
                        break;
                }
            }
            return result;
        }
    }

    handleClickOutside(event) {
        if (this.langRef && !this.langRef.contains(event.target)) {
            if (this.state.show) {
                this.setState({ show: false });
            }
        }
    }

    render() {
        const languages = this.props.languages;
        let languageMenu = null;
        const { header } = this.props;
        const languageControl = this.props.languageControl || this.findControlSection(header, 'MainLanguageBar');
        const languageType = (languageControl && languageControl.properties && languageControl.properties.type) || '';
        let [flagIcon, langName, flagIconOnHover, langNameOnHover] = languageType.split('_');

        if (languages && languages.length > 1) {
            languageMenu = languages.map((language, index) => {
                const langNameOptions = () => {
                    switch (langNameOnHover) {
                        case 'Name':
                            return <span> {language.name} </span>
                        case 'NoName':
                            return "";
                        case 'Code':
                            return <span> {language.id} </span>
                        default:
                            return "";
                    }
                };

                return (<div key={index}
                    className={`tb--flex tb--align-center la-sub-menu_item ${LanguageService.getSelectedLanguage() === language.id ? "la-sub-menu_item__active" : ""}`}
                    onClick={this.selectLanguage.bind(this, language.id)}>
                    {flagIconOnHover === 'Flag' ? <span className={`tb--ns tb--lang ${language.id} ${langNameOptions() ? 'tb--mr-10' : 'tb--only-flag'}`} > </span> : null}

                    <span> {langNameOptions()} </span> </div>
                );
            })
        }

        let selectedLanguageName = languages.filter(lang => lang.id === LanguageService.getSelectedLanguage());

        const selectedLangOption = () => {
            switch (langName) {
                case 'Name':
                    return <span> {selectedLanguageName[0].name} </span>
                case 'NoName':
                    return "";
                case 'Code':
                    return <span > {LanguageService.getSelectedLanguage()} </span>
                default:
                    return ""
            }
        };
        return (
            <React.Fragment>
                {
                    languages && languages.length > 1 && languageControl?.isVisible ? <div ref={this.wrapperRef}
                        onMouseEnter={this.handleHover}
                        onMouseLeave={this.handleBlur}
                        className="lang-area">
                        <div className='lang-area_holder digi_icon-arrow_down'>
                            <div className="lang-area_selected tb--flex tb--align-center">
                                {flagIcon === 'Flag' ? <span className={`tb--ns tb--lang ${selectedLangOption() ? 'tb--mr-10' : 'tb--only-flag'}  ${selectedLanguageName[0].id}`}></span> : null} {selectedLangOption()}
                            </div>
                            <div className={`${this.state.show ? "" : "tb--hide"} la-sub-menu-list`}>
                                <div className={`la-sub-menu`}>{languageMenu}</div>
                            </div>
                        </div >
                    </div>: <></>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        languages: state.settings.languages,
        popupVisible: state.ui.popupVisible,
        translations: state.translations,
        header: state.ui.controls.header
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch,
        props,
    })
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Language));